import React from 'react'
import { Link } from 'react-router-dom'
import { useWindowSize } from 'react-use'
import videoProntuarioMockup from '../../../assets/videos/video-comercial-salva-vidas.mp4'
import videoProntuario from '../../../assets/videos/comercial-prontuario.mp4'
import logoPositronic from '../../../assets/images/positronic.png'
import logo from '../../../assets/images/logo2.png'

export default function () {
	const { width } = useWindowSize()

	const isMobile = width < 1024

	return (
		<div className="bg-white min-h-[100vh] absolute top-0">
			<div className="flex flex-col lg:gap-4 lg:grid lg:grid-cols-[28rem_auto] text-slate-800 sm:mx-4 sm:mt-6 md:mx-32 md:mt-12 leading-loose">
				<div className="relative flex justify-center items-center p-6">
					{isMobile ? (
						<video src={videoProntuario} className="h-[400px] object-contain rounded-[10px]" autoPlay controls loop />
					) : (
						<video src={videoProntuarioMockup} className="h-[500px] rotate-[-5deg] object-contain" autoPlay controls loop />
					)}
				</div>

				<div className="flex flex-col gap-4 h-fit lg:mt-24 mb-8 mx-8">
					<img src={logo} alt="" className="h-24 mt-8 object-contain self-center md:self-start mb-4" />

					<h1 className="text-slate-800 font-bold" style={{ fontSize: 24 }}>Prontuário da Saúde do Cidadão</h1>

					<h2 className="text-slate-800" style={{ fontSize: 16 }}>O Prontuário da Saúde do Cidadão é um aplicativo que dá acesso instantâneo aos seus dados clínicos durante um atendimento de emergência ou consulta médica.</h2>

					<div className="flex gap-4 animated fadeIn delay-400ms mt-8">
						<Link to="/produtos/prontuario#planos" className="md:inline-flex px-8 py-4 md:px-4 md:py-2 bg-emerald-600 text-white rounded-md font-semibold border border-gray-300 hover:text-white hover:bg-emerald-700">
							Assine já
						</Link>

						<Link to="/produtos/prontuario" className="bg-white md:inline-flex px-8 py-4 md:px-4 md:py-2 rounded-md font-semibold border border-gray-300 text-slate-800">
							Saiba mais
						</Link>
					</div>

					<img src={logoPositronic} alt="" className="h-40 mt-8 object-contain" />
				</div>
			</div>
		</div>
	)
}
